import Head from 'next/head';
// import Script from 'next/script';
import { GetServerSideProps } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTheme } from '@forma/forma-ui-theme';
import { Button } from '@forma/forma-ui-kit';
import MetaTags from '@/components/MetaTags';
import MarketplaceInfo from '@/components/views/marketplace/MarketplaceInfo';
import MarketplaceCardBuy from '@/components/views/marketplace/MarketplaceCardBuy';
import getHeadersFromServer from '@/helpers/getHeadersFromServer';
import useMetaTags from '@/hooks/useMetaTags';

import mockApi from '@/api/mockApi';
import ConnectUsModal from '@/components/blocks/ConnectUsModal';

// const enableAnalytics = process.env.ENABLE_ANALYTICS === 'true';
// const dmpCounterId = process.env.DMP_COUNTER_ID;

export const getServerSideProps: GetServerSideProps = async ({ req, res, params }) => {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=14400, stale-while-revalidate=10'
  );
  const slug = 'template-development';
  const locale = params!.locale as string;

  try {
    const mainData = await mockApi.getMainData(locale);
    const pageData = await mockApi.getPromoData(locale, `marketplace/${slug}`);
    const headersParse = await getHeadersFromServer(req);

    return {
      props: {
        initialState: {
          main: mainData,
        },
        pageData,
        headersParse,
        ...(await serverSideTranslations(locale, ['common', 'uikit'])),
      },
    };
  } catch (error) {
    return {
      notFound: true,
    }
  }
};

interface PageProps {
  pageData: {
    title: string,
    subtitle: string,
    description: string,
    icon: string,
    videos?: string[],
    images: string[],
    faq: {
      question: string,
      answer: string
    }[],
    cost: string,
  };
}

const Page = ({ pageData }: PageProps) => {
  const { t } = useTranslation();

  const metaData = {
    title: `${pageData.title} | ${t('main_company_name')}`,
    description: pageData.subtitle,
    keywords: t('main_keywords'),
  };
  const { lang } = useTheme();
  useMetaTags({ lang, ...metaData });

  return (
    <>
      <Head>
        <title>{metaData.title}</title>
        <MetaTags {...metaData} />
      </Head>
      <MarketplaceInfo
        {...pageData}
        prices={
          <MarketplaceCardBuy cost={pageData.cost}>
            {/*<Button
              as={Link}
              viewStyle="primary"
              href={`${lkUrl}/register?lng=${lang}`}
              size="m"
            >
              Заказать разработку шаблона
            </Button>*/}
            <ConnectUsModal
              title="Опишите менеджеру вашу задачу"
              subtitle="Мы передадим задачу квалифицированному юристу, который разработает уникальный шаблон под ваши требования и перенесёт его в ваш личный кабинет DataDoc"
              control={
                <Button
                  viewStyle="primary"
                  size="m"
                >
                  Заказать разработку шаблона
                </Button>
              }
            />
          </MarketplaceCardBuy>
        }
      />
    </>
  );
};

export default Page;
